import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.5 13.25C12.0858 13.25 11.75 12.9142 11.75 12.5C11.75 12.0858 12.0858 11.75 12.5 11.75C12.9142 11.75 13.25 12.0858 13.25 12.5C13.25 12.9142 12.9142 13.25 12.5 13.25Z",
      stroke: "#606269",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.5 17.75C12.0858 17.75 11.75 17.4142 11.75 17C11.75 16.5858 12.0858 16.25 12.5 16.25C12.9142 16.25 13.25 16.5858 13.25 17C13.25 17.4142 12.9142 17.75 12.5 17.75Z",
      stroke: "#606269",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.5 8.75C12.0858 8.75 11.75 8.41421 11.75 8C11.75 7.58579 12.0858 7.25 12.5 7.25C12.9142 7.25 13.25 7.58579 13.25 8C13.25 8.41421 12.9142 8.75 12.5 8.75Z",
      stroke: "#606269",
      "stroke-width": "1.5"
    }, null, -1)
  ]))]))
}
export default { render: render }